// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"9f3d3862","133":"ca36113f","182":"a2c3b674"}[chunkId] + ".chunk.js";
};